import FAQList from './faq/list.es6';


const list = new FAQList();